import React from 'react';
import { Button, FallbackImage, PaperClip, Select } from 'components';
import { AdvertisementService } from 'services';
import { Globals } from 'utils';
import { WhiteImage } from 'assets/img';

const DAYS = [
	{ value: '30', label: '30 días' },
	{ value: '60', label: '60 días' },
	{ value: '90', label: '90 días' },
];

interface Props {
	onClose?: any;
	item?: any;
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			id: '',
			user_id: '',
			type: '',
			days: '',
			advertising_rate_id: '',
			status: '',
			image: '',
			image_blob: '',
			details: [],
		},
		advertisingRates: [],
	}

	componentDidMount() {
		if (this.props.item) this.fillForm();
		else this.getAdvertisingRates();
	}

	fillForm = () => {
		this.setState({
			form: {
				...this.state.form,
				id: this.props.item?.id,
				user_id: this.props.item?.user_id,
				type: this.props.item?.type,
				days: this.props.item?.days,
				advertising_rate_id: this.props.item?.advertising_rate_id,
				status: this.props.item?.status,
				details: this.props.item?.details?.map((i: any) => ({
					title: i.title,
					content: i.content,
					image: i.image,
					document: i.document,
				})),
				image_blob: this.props.item?.details?.at(0)?.image,
			},
		}, () => this.getAdvertisingRates());
	}

	getAdvertisingRates = async () => {
		try {
			const res: any = await AdvertisementService.admin.getAdvertisingRates(this.state.form);

			const rates = res.advertisingRates;
			const advertisingRates = rates.map((rate: any) => ({
				value: String(rate.id),
				label: rate.name,
			}));

			this.setState({ advertisingRates });

		} catch (error) {
			console.error('Error al obtener las tarifas de publicidad:', error);
		}
	};

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	uploadPhoto = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				image: e.target,
				image_blob: e.target?.dataURL,
			},
		})
	}

	submit = async (e: any) => {
		e.preventDefault();

		try {
			if (this.props.item != null) {
				await AdvertisementService.admin.update({
					...this.state.form,
					details: JSON.stringify(this.state.form.details),
					hasFile: true,
					image_blob: '',
					// @ts-ignore,
					image: this.state.form.image?.value || '',
				});
				Globals.showSuccess('Se ha modificado el banner correctamente');
			} else {
				await AdvertisementService.admin.create({
					...this.state.form,
					hasFile: true,
					image_blob: '',
					// @ts-ignore,
					image: this.state.form.image?.value || '',
				});
				Globals.showSuccess('Se ha creado el banner correctamente');
			}

			// ÉXITO: Solo cerramos el modal si todo el proceso anterior no arrojó errores
			this.props.onClose();

		} catch (error) {
			const err = error as any;

			let errorMessage = 'Ocurrió un error al procesar el banner. Intente nuevamente.';

			if (err?.response?.data?.message) {
				const apiMessage = err.response.data.message;
				errorMessage = Array.isArray(apiMessage) ? apiMessage[0] : apiMessage;
			}

			Globals.showError(errorMessage);
		}
	}

	render() {
		return (
			<div className="modal-create-banner">
				<form className="row" onSubmit={ this.submit }>
					<div className="col-12">
						<div className="container-image">
							<PaperClip
								className="paperclip-image"
								value={this.state.form.image}
								onChange={this.uploadPhoto}
							>
								<FallbackImage
									src={this.state.form.image_blob}
									placeholder={WhiteImage}
									className="selected-image"
									placeholderClassName="selected-image inactive"
									alt="Foto"
								/>
							</PaperClip>
						</div>
					</div>
					<div className="col-md-12">
						<Select
							label="Tipo de banner"
							name="advertising_rate_id"
							onChange={this.change}
							value={this.state.form.advertising_rate_id}
							options={this.state.advertisingRates} />
					</div>
					<div className="col-md-12">
						<Select
							label="Tiempo contratado"
							name="days"
							onChange={this.change}
							value={this.state.form.days}
							options={DAYS} />
					</div>
					<div className="col-12 row-buttons">
						<Button type="button" className="btn-close" onClick={ () => this.props.onClose() }>
							Cerrar
						</Button>
						<Button type="submit">
							Aceptar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreate;